import type { AppPolicy } from '@helios/authz';

/**
 * Explicit app policy for web-admin.
 * Admin-only by default.
 */
export const APP_POLICY: AppPolicy = {
  appId: 'web-admin',
  entryAnyOfRoles: ['admin'],
} as const;
